import { ConvertCard } from 'app/src/features/UserJoin/components/FirstStep/ConvertCard'
import { DoNotConvertCard } from 'app/src/features/UserJoin/components/FirstStep/DoNotConvertCard'
import type { PercentageSimulationData } from 'app/src/features/UserJoin/UserJoin'

import { Button } from 'primereact/button'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

export function UserJoinConvertDoNotConvert(
  props: Readonly<{
    accountConvert?: number
    accountDoNotConvert?: number
    nettoConvertitoInWelfare?: number
    dialogFormData?: PercentageSimulationData
    setConfirmPercentageDialogVisible: Dispatch<SetStateAction<boolean>>
    setChosenPercentage: Dispatch<SetStateAction<number>>
    chosenPercentage: number
  }>,
): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.FirstStep' })

  return (
    <>
      <div className='grid gap-4 md:grid-cols-2'>
        <ConvertCard
          accountConvert={props.accountConvert}
          convertedPercentage={props.chosenPercentage}
          nettoConvertitoInWelfare={
            (props.nettoConvertitoInWelfare ?? 0) + (props.dialogFormData?.simulationData?.integrazionePoste ?? 0)
          }
        />
        <DoNotConvertCard accountDoNotConvert={props.accountDoNotConvert} />
      </div>
      <div className='mt-4'>
        <Button
          link
          label={t('modifyPercentageText')}
          onClick={() => {
            props.setConfirmPercentageDialogVisible(true)
          }}
        ></Button>
      </div>
    </>
  )
}
